module.exports = __webpack_public_path__ + "assets/img/bg-line-mecha-3814e170.png";